module.exports = __webpack_public_path__ + "img/promo2.a7d1655a.jpg";